import React, { useEffect } from "react"
import { useState } from "react"
import PhoneVerificationIcon from "../../assets/images/icons/phone-verification.svg"
import circle from "../../assets/images/icons/circle.svg"
import BankDetailIcon from "../../assets/images/icons/bank-details.svg"
import AdditionalDetailsIcon from "../../assets/images/icons/additional-details.svg"
import IDVerificationIcon from "../../assets/images/icons/id-verification.svg"
import SignaturePhoto from "../../assets/images/icons/signature-and-photo.svg"
import Agreement from "../../assets/images/icons/agreement.svg"
import CheckedFill from "../../assets/images/icons/checked-filled.svg"
import AuthorityLetter from "../../assets/images/icons/authority-letter.svg"
import AuthorisedSignatoryIcon from "../../assets/images/icons/authorised-signatory-kyc.svg"
import { useDispatch, useSelector } from "react-redux"
import { setkycSteps } from "store/slices/commonSlice"
import { useUpdateKycStepMutation } from "store/api/kyc/kyc"
import { Spinner } from "reactstrap"

const originalSteps = [
  {
    label: "Phone Verification",
    key: "PHONE_VERIFICATION",
    icon: PhoneVerificationIcon,
  },
  {
    label: "Proof of Identity",
    key: "PAN_GST",
    icon: IDVerificationIcon,
  },
  {
    label: "Additional Details",
    key: "BUSINESS_ADDITIONAL_DETAILS",
    icon: AdditionalDetailsIcon,
  },
  {
    label: "Bank Verification",
    key: "BANK_VERIFICATION",
    icon: BankDetailIcon,
  },
  {
    label: "Demat Verification",
    key: "DEMAT_DETAILS",
    icon: BankDetailIcon,
  },
  {
    label: "Authorised<br/>Person KYC",
    key: "AUTHORISED_SIGNATORY",
    icon: AuthorisedSignatoryIcon,
  },
  {
    label: "Photo",
    key: "PHOTO",
    icon: SignaturePhoto,
  },
  {
    label: "Upload <br/>Authority Letter",
    key: "AUTHORITY_LETTER",
    icon: AuthorityLetter,
  },
  {
    label: "ID Verification",
    key: "ID_VERIFICATION",
    icon: IDVerificationIcon,
  },
  {
    label: "Additional Details",
    key: "ADDITIONAL_DETAILS",
    icon: AdditionalDetailsIcon,
  },
  {
    label: "Agreement Details",
    key: "AGREEMENT_DETAILS",
    icon: Agreement,
  },
]
const iconMap = originalSteps.reduce((acc, item) => {
  acc[item.key] = item.icon
  return acc
}, {})

const getIcon = (key) => iconMap[key] || null

const KycProgressBar = ({ querySteps, currentStep }) => {
  const { user, userType } = useSelector((state) => state.user)
  const [steps, setSteps] = useState([])
  const [clickedStep, setClickedStep] = useState("")
  const dispatch = useDispatch()
  const [updateStep, { isLoading }] = useUpdateKycStepMutation()

  useEffect(() => {
    if (querySteps && querySteps?.data?.steps.length > 0) {
      let currentIndex = 0
      if (currentStep === "FINAL_STEP") {
        currentIndex = querySteps?.data?.steps.length - 1
      } else if (currentStep === "BANK_DETAILS") {
        currentIndex = 3
      } else {
        currentIndex = querySteps?.data?.steps.findIndex(
          (step) => step.key && step.key.includes(currentStep)
        )
      }

      const updatedSteps = querySteps?.data?.steps.reduce(
        (acc, item, index, arr) => {
          acc.push({
            ...item,
            stepNo: index + 1,
            type: "step",
            icon: getIcon(item.key),
          })

          const isLastStep = index === arr.length - 1
          if (!isLastStep) {
            if (index >= 0 && index < currentIndex) {
              acc.push({ icon: CheckedFill })
            } else {
              acc.push({ icon: circle })
            }
          }

          return acc
        },
        []
      )

      setSteps([...updatedSteps.map((k) => ({ ...k, key: [k.key] }))])
      dispatch(
        setkycSteps(
          updatedSteps
            .filter((item) => item.stepNo)
            .map((k) => ({ ...k, key: [k.key] }))
        )
      )
    }
  }, [querySteps, currentStep])

  const canEditStep = (steps) => {
    return !steps.includes(currentStep)
  }

  const goToStep = async (kyc_status) => {
    setClickedStep(kyc_status)

    try {
      await updateStep({ kyc_status }).unwrap()
      window.location.reload()
    } catch (error) {}
  }

  return (
    <>
      <div
        className={`progress-bar-wrapper ${
          querySteps?.data?.steps.length === 1 ? "single-step" : ""
        }`}
      >
        {steps.map((item, index) => (
          <React.Fragment key={`steps_${index}`}>
            {item.type === "step" ? (
              <div
                className={`progress-step-wrapper ${item.key.join(" ")} ${
                  canEditStep(item.key) ? "cp can-edit" : ""
                }`}
                onClick={(e) =>
                  canEditStep(item.key)
                    ? goToStep(item.key[0])
                    : e.preventDefault()
                }
              >
                <div className="progress-step">
                  {isLoading && clickedStep === item.key[0] ? (
                    <Spinner size={"sm"} />
                  ) : (
                    <img src={item.icon} alt="" />
                  )}
                </div>
                <div className="step-section">
                  <p>Step {item.stepNo}</p>
                  <h5
                    dangerouslySetInnerHTML={{
                      __html: item.label,
                    }}
                  ></h5>
                </div>
              </div>
            ) : (
              <div className="progress">
                <img src={item.icon} alt="" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* <div className="mobile-progress-bar-wrapper">
        <div className="progress-bar-inner-box">
          <div className="progress-bar-icon">
            <img src={PhoneVerificationIcon} alt="" />
          </div>
          <div className="progress-bar-text">
            <p>Step 1</p>
            <h5>Phone Verification</h5>
          </div>
        </div>

        <div className="progress-bar-inner-box">
          <div className="progress-bar-icon">
            <img src={IDVerificationIcon} alt="" />
          </div>
        </div>
      </div> */}
    </>
  )
}

export default KycProgressBar
